<template>
  <layout-content>
    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import FilterComponent from '@phone-number/components/numbers-buy-table-filter';
  import TableComponent from '@phone-number/components/numbers-buy-table';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterComponent,
      TableComponent
    },

    created() {
      this.getList();
    },

    methods: {
      ...mapActions('phone-number/user_countries/list', ['getList'])
    }
  };
</script>
